var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5012\u8BA1\u65F6\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 9
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.5%",
    y: "-25.0%",
    width: "159.1%",
    height: "159.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.767575499   0 0 0 0 0.935762709   0 0 0 0 0.878817434  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7BA1\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406\\u5907\\u4EFD-3",
    transform: "translate(-489.000000, -367.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u798F\\u5229\\u6A21\\u5757\\u5907\\u4EFD-3",
    transform: "translate(232.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u53F7\\u6253\\u4F4D\\u5907\\u4EFD-3",
    transform: "translate(241.600000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5012\\u8BA1\\u65F6\\u5907\\u4EFD",
    transform: "translate(17.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-7"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#48C79C",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "yuyue-2",
    transform: "translate(6.000000, 6.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1715973,6.01357094 C7.1637045,6.01357094 6.34319459,6.83351303 6.34319459,7.84197365 C6.34319459,8.85043427 7.16313668,9.67037635 8.1715973,9.67037635 C9.17949009,9.67037635 10,8.85043427 10,7.84197365 C10,6.83351303 9.17949009,6.01357094 8.1715973,6.01357094 Z M9.02844813,8.13099755 L8.17102947,8.13099755 C8.0114701,8.13099755 7.88200556,8.00153301 7.88200556,7.84197365 L7.88200556,6.68985281 C7.88200556,6.53029345 8.0114701,6.40082891 8.17102947,6.40082891 C8.33058884,6.40082891 8.46005338,6.53029345 8.46005338,6.68985281 L8.46005338,7.55294974 L9.02844813,7.55294974 C9.1880075,7.55294974 9.31747203,7.68241428 9.31747203,7.84197365 C9.31747203,8.00153301 9.1880075,8.13099755 9.02844813,8.13099755 L9.02844813,8.13099755 Z",
    id: "\\u5F62\\u72B6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82681279,3.32434262 L9.82681279,2.22616534 C9.82681279,1.6515245 9.36119471,1.18590642 8.78655386,1.18590642 L8.29992618,1.18590642 L8.29992618,0.570779513 C8.29992618,0.255546692 8.04437949,2.76604085e-14 7.72914667,0 C7.41391385,5.79073297e-17 7.15836716,0.255546692 7.15836716,0.570779513 L7.15836716,1.18590642 L7.15836716,1.18590642 L2.85929249,1.18590642 L2.85929249,0.585003691 C2.85929249,0.261915074 2.59737741,-5.93504161e-17 2.2742888,0 C1.95120018,-2.27609921e-16 1.68928511,0.261915074 1.68928511,0.585003691 L1.68928511,1.18590642 L1.68928511,1.18590642 L1.04025893,1.18590642 C0.46561808,1.18590642 0,1.6515245 0,2.22616534 L0,3.32434262 L9.82681279,3.32434262 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.90239043 L0,8.52790857 C0,9.10254942 0.46561808,9.5681675 1.04025893,9.5681675 L6.40338425,9.5681675 C5.967861,9.12242337 5.69871103,8.51314507 5.69871103,7.84197365 C5.69871103,6.4786212 6.80767702,5.36908738 8.1715973,5.36908738 C8.80756345,5.36908738 9.38788257,5.61041383 9.82681279,6.00618919 L9.82681279,3.90239043 L0,3.90239043 Z M4.07018341,7.67048991 L1.64840157,7.67048991 C1.49792743,7.67048991 1.37584464,7.54102538 1.37584464,7.38146601 C1.37584464,7.22190664 1.49792743,7.0924421 1.64840157,7.0924421 L4.07018341,7.0924421 C4.22065754,7.0924421 4.34274033,7.22190664 4.34274033,7.38146601 C4.34274033,7.54102538 4.22065754,7.67048991 4.07018341,7.67048991 Z M4.07018341,5.78871148 L1.64840157,5.78871148 C1.49792743,5.78871148 1.37584464,5.65924694 1.37584464,5.49968758 C1.37584464,5.34012821 1.49792743,5.21066367 1.64840157,5.21066367 L4.07018341,5.21066367 C4.22065754,5.21066367 4.34274033,5.34012821 4.34274033,5.49968758 C4.34274033,5.65924694 4.22065754,5.78871148 4.07018341,5.78871148 Z",
    id: "\\u5F62\\u72B6"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.f8bdf0d3d7dfd84b2aa267296a56be43.svg";
export { ForwardRef as ReactComponent };